import App from '../index.js';
import { uniqBy, isEmpty } from 'lodash';


const SUMMARIZE_AI_TYPE_SEARCH_RESULTS = 'search_results';
const SUMMARIZE_AI_TYPE_CANNED_RESPONSE = 'canned_response';
const SUMMARIZE_AI_TYPE_AI_SUMMARY = 'ai_summary';

const INDEX_MODE_CRAWL = 'crawl';

App.BotSetting = (function () {

    const elPrimaryColor = $('#primary_color');
    const elSecondColor = $('#secondary_color');
    const elIconBackgroundColor = $('#icon_background_color');
    const elIconSize = $('#icon_size');
    const elWindowRadius = $('#window_radius');
    const elResponseStyleIcon = $('#response_style_icon');
    const elChatbotName = $('#chatbot_name');
    const elWelcomeMessage = $('#welcome_message');
    const elHeaderTextColor = $('#header_text_color');
    const elNewUserPromptTextColor = $('#new_user_prompt_text_color');
    const elNewUserPromptBGColor = $('#new_user_prompt_background_color');

    const chatBotStyle = {
        header_text_color: elHeaderTextColor.val(),
        primary_color: elPrimaryColor.val(),
        secondary_color: elSecondColor.val(),
        new_user_prompt_text_color: elNewUserPromptTextColor.val(),
        new_user_prompt_background_color: elNewUserPromptBGColor.val(),
        icon_background_color: elIconBackgroundColor.val(),
        icon_size: elIconSize.val() + 'px',
        logo: null,
        icon: null,
        chat_starting_position: $('[name="chat_starting_position"]:checked').val(),
        disable_question_button: parseInt($('[name="disable_question_button"]:checked').val()) === 1
    };

    let selectedSearchEngineOptions = []; // Array to store selected options

    function getRGB ( c ) {
        return parseInt(c, 16) || c
    }

    function getsRGB ( c ) {
        return getRGB(c) / 255 <= 0.03928
            ? getRGB(c) / 255 / 12.92
            : Math.pow((getRGB(c) / 255 + 0.055) / 1.055, 2.4)
    }

    function getLuminance ( hexColor ) {
        return (
            0.2126 * getsRGB(hexColor.substr(1, 2)) +
            0.7152 * getsRGB(hexColor.substr(3, 2)) +
            0.0722 * getsRGB(hexColor.substr(-2))
        )
    }

    function getContrast ( f, b ) {
        const L1 = getLuminance(f)
        const L2 = getLuminance(b)
        return (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05)
    }

    function getTextColor ( bgColor ) {
        const whiteContrast = getContrast(bgColor, '#ffffff')
        const blackContrast = getContrast(bgColor, '#000000')

        return whiteContrast > blackContrast ? '#ffffff' : '#000000'
    }

    function initImageInputs () {
        $('body').on('change', '#customize_options_form .img-input input[type=file]', function ( e ) {
            const fileInput = e.target;
            const [ file ] = fileInput.files;
            const elImgPreview = $(this).closest('.img-input').find('.img-preview');
            if (file) {
                let img = URL.createObjectURL(file);
                elImgPreview.addClass('active');
                elImgPreview.find('img').attr('src', img);

                if ($(fileInput).hasClass('logo-picker')) {
                    chatBotStyle.logo = img;
                    updateChatBotPreviewStyling();
                }

                if ($(fileInput).hasClass('icon-picker')) {
                    chatBotStyle.icon = img;
                    updateChatBotPreviewStyling();
                }
            } else {
                elImgPreview.removeClass('active');
            }
        });
    }

    function initColorPickers () {

        elPrimaryColor.spectrum({
            color: elPrimaryColor.val(),
            change: function ( color ) {
                $('#primary_color_text').val(color.toHexString())
                chatBotStyle.primary_color = color.toHexString();
                updateChatBotPreviewStyling();
            }
        });

        $("#primary_color_text").on('click', function () {
            elPrimaryColor.spectrum("toggle");
            return false;
        });

        elSecondColor.spectrum({
            color: elSecondColor.val(),
            change: function ( color ) {
                $('#secondary_color_text').val(color.toHexString())
                chatBotStyle.secondary_color = color.toHexString();
                updateChatBotPreviewStyling();
            }
        });

        $("#secondary_color_text").on('click', function () {
            elSecondColor.spectrum("toggle");
            return false;
        });

        elIconBackgroundColor.spectrum({
            color: elIconBackgroundColor.val(),
            change: function ( color ) {
                $('#icon_background_color_text').val(color.toHexString())
                chatBotStyle.icon_background_color = color.toHexString();
                updateChatBotPreviewStyling();
            }
        });

        $("#icon_background_color_text").on('click', function () {
            elIconBackgroundColor.spectrum("toggle");
            return false;
        });

        elHeaderTextColor.spectrum({
            color: elHeaderTextColor.val(),
            change: function ( color ) {
                $('#header_text_color_text').val(color.toHexString())
                chatBotStyle.header_text_color = color.toHexString();
                updateChatBotPreviewStyling();
            }
        });

        $("#header_text_color_text").on('click', function () {
            elHeaderTextColor.spectrum("toggle");
            return false;
        });

        elNewUserPromptTextColor.spectrum({
            color: elNewUserPromptTextColor.val(),
            change: function ( color ) {
                $('#new_user_prompt_text_color_text').val(color.toHexString())
                chatBotStyle.new_user_prompt_text_color = color.toHexString();
                updateChatBotPreviewStyling();
            }
        });

        $("#new_user_prompt_text_color_text").on('click', function () {
            elNewUserPromptTextColor.spectrum("toggle");
            return false;
        });

        elNewUserPromptBGColor.spectrum({
            color: elNewUserPromptBGColor.val(),
            change: function ( color ) {
                $('#new_user_prompt_background_color_text').val(color.toHexString())
                chatBotStyle.new_user_prompt_background_color = color.toHexString();
                updateChatBotPreviewStyling();
            }
        });

        $("#new_user_prompt_background_color_text").on('click', function () {
            elNewUserPromptBGColor.spectrum("toggle");
            return false;
        });
    }

    function preventPageLoad () {
        if (!touched) {
            window.onbeforeunload = function () {
                return touched ? "You haven't save your changes! are you sure you want to leave?" : false;
            }
            touched = true;
        }
    }

    function initWysiwyg () {
        App.wysiwygEditor('#no_results_found_message', 400, null)
        App.wysiwygEditor('#new_user_prompt_message', 400, null)
        App.wysiwygEditor('#welcome_message', 400, function ( data ) {
        }, function ( el, content ) {
            el.val(content);
            updateChatBotPreviewStyling();
        });

        App.wysiwygEditor('.subdomain-style-setting-list .subdomain-style-setting-item .welcome-message-field:not(.mce-active)', 400, null);
    }

    function updateChatBotPreviewStyling () {
        let el = $('.preview-holder');

        el.find('.header .name').toggle($('[name="display_chatbot_name"]:checked').val() === '1').css('color', chatBotStyle.header_text_color).text(elChatbotName.val());
        el.find('.chatBubble.welcome-message').html(elWelcomeMessage.val());

        if (chatBotStyle.secondary_color) {
            el.find('.header').css({
                'background-color': chatBotStyle.secondary_color,
                'color': getTextColor(chatBotStyle.secondary_color)
            });
        }

        if (chatBotStyle.logo) {
            el.find('.header .logo').attr('src', chatBotStyle.logo);
        }

        if (chatBotStyle.icon) {
            el.find('.bubble .imageIcon').attr('src', chatBotStyle.icon);
        }

        if (chatBotStyle.icon_background_color) {
            el.find('.bubble, .chatBox .chatItem.bubbleItem .bubbleItemProfile').css({
                'background-color': chatBotStyle.icon_background_color
            });
        }

        if (chatBotStyle.icon_size) {
            el.find('.bubble .imageIcon').css({
                width: elIconSize.val() + 'px',
                height: elIconSize.val() + 'px'
            });
        }

        if (chatBotStyle.primary_color) {
            el.find('.chatBox .sendForm .sendButton').css({
                'background-color': chatBotStyle.primary_color,
                'border-color': chatBotStyle.primary_color,
                'color': getTextColor(chatBotStyle.primary_color)
            });

            el.find('.chatBox .chatItem.response .chatBubble').css({
                'border-color': chatBotStyle.primary_color
            });

            el.find('.chatBox .chatItem.sender.bubbleItem .chatBubble').css({
                'background-color': chatBotStyle.primary_color,
                'border-color': chatBotStyle.primary_color,
                'color': getTextColor(chatBotStyle.primary_color)
            });
            el.find('.frameFooter').css({
                'color': chatBotStyle.primary_color
            });
        }

        if (chatBotStyle.secondary_color) {
            el.find('.header').css({
                'background-color': chatBotStyle.secondary_color,
                'color': getTextColor(chatBotStyle.secondary_color)
            });
        }

        el.find('.chatList').toggleClass('startFromBottom', chatBotStyle.chat_starting_position === 'bottom');
        el.find('.sendForm').toggleClass('d-none', chatBotStyle.disable_question_button);

        let elResponseStyleValue = $('[name="response_style"]:checked').val();
        let elResponseStyleIconValue = elResponseStyleIcon.val();

        el.find('.alwaysonFrameContainer').css('border-radius', elWindowRadius.val() + 'px');
        el.find('.alwaysonFrameContainer .chatItem.response').toggleClass('bubbleItem', elResponseStyleValue !== 'box');

        let imgSrc = elResponseStyleIcon.val() === 'trigger_icon' ? $('#trigger-img').attr('src') : (elResponseStyleIconValue === 'logo' ? $('#logo-img').attr('src') : '');
        let elChatProfile = el.find('.alwaysonFrameContainer .chatItem.response .chatItemProfile');

        elChatProfile.toggleClass('d-none', elResponseStyleValue !== 'bubble_with_logo');

        if (elResponseStyleIcon.val() === 'logo') {
            elChatProfile.css('background', chatBotStyle.icon_background_color);
        }

        elChatProfile.find('.chatItemProfileImg').attr('src', imgSrc);

        $('#fallback_pdf_file_field_label').html($('#fallback_pdf_file_display > *').length > 0 ? 'Replace PDF' : 'Upload PDF');
    }

    function updateWindowRadius () {
        let val = $(this).val();
        $('#window_radius_form_field_group .range-field-value').text(val);
        updateChatBotPreviewStyling();
    }

    function updateResponseStyle () {
        if ($(this).val() === 'bubble_with_logo') {
            $('[name="response_style_icon" ]').removeClass('d-none');
        } else {
            elResponseStyleIcon.addClass('d-none');
        }
        updateChatBotPreviewStyling();
    }

    function updateChatPdfFile ( e ) {
        const el = $(this);
        const elDisplay = el.closest('.pdf-options-holder').find('.pdf-display');
        const elPdfID = el.closest('.form-group-holder').find('.pdf-id');

        if (el.val()) {
            const fileName = el.val().split('\\').pop();
            elDisplay.html(`<span>${ fileName }</span>`);
            elPdfID.val('');
        } else {
            if (elDisplay.data('existing-url')) {
                elDisplay.html(`<a href="${ elDisplay.data('existing-url') }" target="_blank">${ elDisplay.data('existing-name') }</a>`)
                elPdfID.val(elPdfID.data('id'));
            } else {
                elDisplay.html('');
            }
        }

        el.closest('.pdf-file-button').find('span').html(elDisplay.find('> *').length > 0 ? 'Replace' : 'Upload');
    }

    function templateSelectionAjax ( repo ) {
        const elOption = $(repo.element);
        elOption.attr('data-bot-item-id', repo.bot_item_id).data('type', repo.type).attr('data-type', repo.type);

        if (!repo.type) {
            repo.type = elOption.closest('select').data('type')
        }

        if (!repo.category) {
            repo.category = elOption.closest('select').data('category')
        }

        if (!repo.primary_question) {
            repo.primary_question = elOption.closest('select').data('primary-question')
        }

        const icon = ['question', 'primary_question'].includes(repo.type) ? '<i class="fa-regular fa-circle-question"></i>' : ( repo.type === 'category' ? '<i class="fa-regular fa-folder-open"></i>' : '');

        if(repo.type === 'category') {
            return $(`<span>${icon} <strong>${ repo.text }</strong></span>`);
        } else if (repo.type === 'primary_question') {
            return $(`<span>${icon} <strong>${repo.category}</strong> - ${ repo.text }</span>`);
        } else if(repo.type === 'question') {
            return $(`<span>${icon} <strong>${repo.category}</strong> - <strong>${ repo.primary_question }</strong> - ${repo.text}</span>`);
        }

        return $(`<span>${icon} <strong>${ repo.text }</strong></span>`);
    }

    // Format the dropdown options
    function formatOptionAjax(option) {
        if (!option.id) {
            return option.text; // Return unmodified for the placeholder
        }

        const type = option?.type || $(option.element).data('type'); // Get the option type

        if ( type === 'category' ) {
            return $('<span><i class="fa-regular fa-folder-open"></i> <strong>' + option.text + '</strong></span>');
        } else if( type === 'primary_question' ) {
            return $('<div class="px-4"><i class="fa-regular fa-circle-question"></i> ' +
                '<span><strong>' + option.text + '</strong></span>' +
            '</div>');
        } else if( type === 'question' ) {
            return $('<div class="px-4 mx-4"><i class="fa-regular fa-circle-question"></i> ' +
                '<span>' + option.text  + '</span>' +
            '</div>');
        }

        return $('<span>' + option.text + '</span>');
    }

    function extractCategories(data) {
        const result = [];

        data.items.forEach((category) => {
            // Push top-level category
            result.push({
                id: category.id,
                text: category.text,
                type: 'category'
            });

            // Iterate over children in the category
            if (category.children && category.children.length > 0) {
                category.children.forEach((primaryQuestion) => {
                    result.push({
                        id: primaryQuestion.id,
                        text: primaryQuestion.text,
                        type: 'primary_question',
                        bot_item_id: primaryQuestion.bot_item_id,
                        category: category.text,
                    });

                    // Check for nested children (if any)
                    if (primaryQuestion.children && primaryQuestion.children.length > 0) {
                        primaryQuestion.children.forEach((secondaryQuestion) => {
                            result.push({
                                id: secondaryQuestion.id,
                                text: secondaryQuestion.text,
                                type: 'question',
                                bot_item_id: secondaryQuestion.bot_item_id,
                                category: category.text,
                                primary_question: primaryQuestion.text,
                            });
                        });
                    }
                });
            }
        });

        return result;
    }

    function initSearchableSelectAjax ( el = null) {
        const elSearchableSelectItems = el ? el : $('.inclusion-urls-holder .searchable-select-ajax');

        elSearchableSelectItems.each(function () {
            const elSearchableSelectItem = $(this);
            const initialData = [ {
                id: elSearchableSelectItem.val(),
                text: elSearchableSelectItem.data('question'),
                primary_question: elSearchableSelectItem.data('primary-question'),
                category: elSearchableSelectItem.data('category'),
            } ];

            elSearchableSelectItem.select2({
                theme: "bootstrap-5",
                dropdownCssClass: 'searchable-select-dropdown',
                ajax: {
                    delay: 250,
                    method: 'POST',
                    url: elSearchableSelectItem.data('url'),
                    data: function ( params ) {
                        if (params.term) {
                            $('.searchable-select-dropdown .select2-results .loading-results').show()
                        } else {
                            $('.searchable-select-dropdown .select2-results .loading-results').hide()
                        }

                        return {
                            _token: $('[name="csrf-token"]').attr('content'),
                            text: params.term,
                            type: 'ai_summary',
                            exclude_bot_items: []
                        };
                    },
                    processResults: function ( data ) {
                        return {
                            results: extractCategories(data)
                        }
                    }
                },
                templateSelection: templateSelectionAjax,
                templateResult: formatOptionAjax, // Customize option appearance
                data: initialData
            });
        });
    }

    function templateSelection ( repo ) {
        const elOption = $(repo.element);

        if (!repo.type) {
            repo.type = elOption.data('type')
        }

        if (!repo.category) {
            repo.category = elOption.data('category')
        }

        const icon = repo.type === 'primary_question' ? '<i class="fa-regular fa-circle-question"></i>' : ( elOption.data('type') === 'category' ? '<i class="fa-regular fa-folder-open"></i>' : '');

        if(repo.type === 'category') {
            return $(`<span>${icon} <strong>${ repo.text }</strong></span>`);
        } else if (repo.type === 'primary_question') {
            return $(`<span>${icon} <strong>${repo.category}</strong> - ${ repo.text }</span>`);
        }

        return $(`<span><strong>${ repo.text }</strong></span>`);
    }

    // Format the dropdown options
    function formatOption(option) {
        if (!option.id) {
            return option.text; // Return unmodified for the placeholder
        }

        const type = $(option.element).data('type'); // Get the option type

        if ( type === 'category' ) {
            return $('<span><i class="fa-regular fa-folder-open"></i> ' + option.text + '</span>');
        } else if( type === 'primary_question' ) {
            return $('<span class="px-4"><i class="fa-regular fa-circle-question"></i> ' + option.text + '</span>');
        }

        return $('<span>' + option.text + '</span>');
    }

    function initSearchableSelect ( el = null ) {
        const elSearchableSelectItems = el ? el : $('.inclusion-pdfs-form .searchable-select');

        elSearchableSelectItems.each(function () {
            const elSearchableSelectItem = $(this);

            elSearchableSelectItem.select2({
                theme: "bootstrap-5",
                templateSelection: templateSelection,
                templateResult: formatOption, // Customize option appearance
            });
        });
    }

    function updateFallbackPdfFile ( e ) {
        let elFallbackPdfFileDisplay = $('#fallback_pdf_file_display');
        if (e.target.files[0]) {
            elFallbackPdfFileDisplay.html(`<div class="pdf-file-item">
                <div class="pdf-file-name">
                    <span>${ e.target.files[0]?.name }</span>
                </div>
                <div class="pdf-file-action">
                    <a href="#" class="pdf-file-remove"><i class="fa fa-trash"></i></a>
                </div>
            </div>`);
        } else {
            elFallbackPdfFileDisplay.html('');
        }

        $('#fallback_pdf_file_field_label').html(elFallbackPdfFileDisplay.find('> *').length > 0 ? 'Replace PDF' : 'Upload PDF');
    }

    function removeFallbackPdfFile ( e ) {
        e.preventDefault();
        $('[name="fallback_pdf_file_remove"]').prop('checked', true).attr('checked', true);
        $(this).closest('.pdf-file-item').remove();
        $('#fallback_pdf_file_field_label').html('Upload PDF');
    }

    function buildWysiwygEditor ( elParent ) {
        App.wysiwygEditor(elParent + ' .text-editor', 100, function ( el, data ) {
            preventPageLoad();
        });
    }

    function sortSelectedSearchEnginesOptions () {
        let elSelectedChoices = $('.search-engines-holder .select2-selection__choice');
        let elSelectedContainer = $('.search-engines-holder .select2-selection__rendered');

        // jQuery 4 removed its undocumented .sort() (a copy of Array.prototype.sort);
        // call the native method directly on the array-like jQuery collection instead.
        const sortedItems = Array.prototype.sort.call(elSelectedChoices, function ( a, b ) {
            return selectedSearchEngineOptions.indexOf($(a).attr('title').toLowerCase()) - selectedSearchEngineOptions.indexOf($(b).attr('title').toLowerCase());
        });

        elSelectedContainer.html(sortedItems);
    }

    function updateSelectedSearchEngine () {
        const elSelectedSearchEngine = $('.selected-search-engines');

        elSelectedSearchEngine.html('');
        $.each(selectedSearchEngineOptions, function ( index, item ) {
            elSelectedSearchEngine.append('<input type="hidden" name="other_setting[search_engines][' + index + ']" value="' + item + '">');
        });
    }

    function initMultiSelect () {
        const elSearchEngine = $('#search_engines');
        elSearchEngine.select2({
            theme: "bootstrap-5"
        });

        elSearchEngine.on('select2:select', function ( e ) {
            selectedSearchEngineOptions.push(e.params.data.id);
            updateSelectedSearchEngine();
            sortSelectedSearchEnginesOptions();
        });

        elSearchEngine.on('select2:unselect', function ( e ) {
            selectedSearchEngineOptions = selectedSearchEngineOptions.filter(option => option !== e.params.data.id);
            updateSelectedSearchEngine();
            sortSelectedSearchEnginesOptions();
        });

        // Sort selected options initially
        $('.selected-search-engines input').each(function ( index, item ) {
            selectedSearchEngineOptions.push($(item).val());
        });

        sortSelectedSearchEnginesOptions();
    }

    function setupColorPicker () {
        const elItems = $('#subdomain_style_form .color-picker-holder:not(.color-picker-mounted)');

        elItems.each(function ( index, elItem ) {
            const elItemColorPicker = $(elItem);
            const elItemInput = elItemColorPicker.find('.input-picker input');
            const elItemInputText = $(elItem).find('.input-holder .item-field');

            elItemColorPicker.closest('.color-picker-holder').addClass('color-picker-mounted');

            elItemInput.spectrum({
                color: elItemInput.val(),
                change: function ( color ) {
                    elItemInputText.val(color.toHexString());
                }
            });

            elItemInputText.on('click', function () {
                elItemInput.spectrum("toggle");
                return false;
            });
        });
    }

    function setupImageUploadField () {
        // Use event delegation to handle dynamically added elements
        $('body').on('change', '#subdomain_style_form .img-input input[type=file]', function ( e ) {
            const fileInput = e.target;
            const [ file ] = fileInput.files;
            const $elImgPreview = $(this).closest('.img-input').find('.img-preview');

            if (file) {
                const imgURL = URL.createObjectURL(file);
                $elImgPreview.addClass('active');
                $elImgPreview.find('img').attr('src', imgURL);
            } else {
                $elImgPreview.removeClass('active');
                $elImgPreview.find('img').removeAttr('src');
            }
        });
    }

    function setupSubdomainStyleFieldAttributes () {
        const subdomainStyleSettingItemsEl = $('#subdomain_style_form .subdomain-style-setting-item');

        subdomainStyleSettingItemsEl.each(function ( index, subdomainStyleSettingItemEl ) {
            const fieldsEl = $(subdomainStyleSettingItemEl).find('.item-field');
            fieldsEl.attr('data-counter', index).data('counter', index);

            fieldsEl.each(function ( indexField, fieldEl ) {
                $(fieldEl).attr('name', 'subsite_styling[' + index + '][' + $(fieldEl).data('field-name') + ']');
            });
        });
    }

    function onSubdomainStyleFormSubmit ( e ) {
        e.preventDefault();
        const elForm = $(this);
        setupSubdomainStyleFieldAttributes();
        elForm[0].submit();
    }

    function onClickedAddSubdomainRow () {
        let parent = $(this).closest('.subdomain-style-setting-wrapper'),
            tpl = $('#subdomain_styling_tpl').clone(),
            newCount = parseInt(parent.find('.subdomain-style-setting-item:last').data('counter') || 0) + 1;

        tpl.find('.img-input [type="file"]').each(function ( index, elFile ) {
            const id = $(elFile).data('field-name') + '_field_' + newCount;
            $(this).attr('id', id).closest('label').attr('for', id);
        });

        tpl.find('.subdomain-style-setting-item').attr('data-counter', newCount);

        parent.find('.subdomain-style-setting-list').append(tpl.html());

        App.wysiwygEditor('.subdomain-style-setting-list .subdomain-style-setting-item .welcome-message-field:not(.mce-active)', 400, null);
        setupColorPicker();
    }

    function onChangeSearchPageSubsite () {
        const val = $(this).val();
        $('#url_detection_form_group').toggleClass('d-none', val !== 'url_detection');
    }


    function setupSearchableUrlsSetting () {
        $('body')
            .on('change', '[name="searchable_url_setting[search_page_subsite]"]', onChangeSearchPageSubsite)
            .on('change', '[name="chat_starting_position"]', function (  ) {
                chatBotStyle.chat_starting_position = $('[name="chat_starting_position"]:checked').val();
                updateChatBotPreviewStyling();
            })
            .on('change', '[name="disable_question_button"]', function (  ) {
                chatBotStyle.disable_question_button = parseInt($('[name="disable_question_button"]:checked').val()) === 1;
                updateChatBotPreviewStyling();
            })
            .on('click', '.searchable-urls-holder .add-link', function () {
                let parent = $(this).closest('.searchable-urls-holder'),
                    tpl = $('#searchable_url_tpl').html();

                parent.find('.searchable-urls-form').append(tpl);
            })
            .on('click', '.searchable-urls-holder  .remove-link', function () {
                $(this).closest('.form-group').remove();
            })
            .on('click', '.exclusion-urls-holder .add-link', function () {
                let parent = $(this).closest('.exclusion-urls-holder'),
                    tpl = $('<div/>').html($('#exclusion_url_tpl').html()),
                    counter = parseInt($('.exclusion-urls-holder .form-group:last-child').data('counter')) + 1;

                tpl.find('.form-group').attr('data-counter', counter).data('counter', counter);
                tpl.find('.apply-match-type-starts-with .form-check-input').attr('id', 'apply_match_type_starts_with_' + counter).attr('name', 'searchable_url_setting[exclusion_urls][' + counter + '][apply_match_type]');
                tpl.find('.apply-match-type-starts-with .form-check-label').attr('for', 'apply_match_type_starts_with_' + counter);
                tpl.find('.apply-match-type-exact-match .form-check-input').attr('id', 'apply_match_type_exact_match_' + counter).attr('name', 'searchable_url_setting[exclusion_urls][' + counter + '][apply_match_type]');
                tpl.find('.apply-match-type-exact-match .form-check-label').attr('for', 'apply_match_type_exact_match_' + counter);
                tpl.find('.form-email').attr('name', 'searchable_url_setting[exclusion_urls][' + counter + '][url]');

                parent.find('.exclusion-urls-form').append(tpl.html());
            })
            .on('click', '.exclusion-urls-holder .remove-link', function () {
                $(this).closest('.form-group').remove();
            })
            .on('click', '.inclusion-urls-holder .add-row', function () {
                let parent = $(this).closest('.inclusion-urls-holder'),
                    tpl = $('<div/>').html($('#inclusion_url_tpl').html()),
                    counter = parseInt($('.inclusion-urls-holder .form-group:last-child').data('counter') || 0) + 1;

                tpl.find('.form-group').attr('data-counter', counter).data('counter', counter);
                tpl.find('.form-select').attr('id', 'inclusion_urls_' + counter + '_bot_item_id').attr('name', 'searchable_url_setting[inclusion_urls][' + counter + '][question_id]');
                tpl.find('.apply-match-type-starts-with .form-check-input').attr('id', 'inclusion_urls_apply_match_type_starts_with_' + counter).attr('name', 'searchable_url_setting[inclusion_urls][' + counter + '][filters][0][apply_match_type]');
                tpl.find('.apply-match-type-starts-with .form-check-label').attr('for', 'inclusion_urls_apply_match_type_starts_with_' + counter);
                tpl.find('.apply-match-type-exact-match .form-check-input').attr('id', 'inclusion_urls_apply_match_type_exact_match_' + counter).attr('name', 'searchable_url_setting[inclusion_urls][' + counter + '][filters][0][apply_match_type]');
                tpl.find('.apply-match-type-exact-match .form-check-label').attr('for', 'inclusion_urls_apply_match_type_exact_match_' + counter);
                tpl.find('.form-url').attr('name', 'searchable_url_setting[inclusion_urls][' + counter + '][filters][0][url]');

                parent.find('.inclusion-urls-form').append(tpl.html());
                initSearchableSelectAjax($('.inclusion-urls-holder .form-group:last-child .searchable-select-ajax'));
            })
            .on('click', '.inclusion-urls-holder .add-link', function () {
                let parent = $(this).closest('.url-options-wrapper'),
                    tpl = $('<div/>').html($('#inclusion_url_tpl .url-options-group').html()),
                    counter = parseInt(parent.closest('.form-group').data('counter') || 0),
                    urlCounter = parseInt(parent.find('.url-options-group .url-options-holder:last-child').data('counter') || 0) + 1;

                tpl.find('.url-options-holder').attr('data-counter', urlCounter).data('counter', urlCounter);
                tpl.find('.apply-match-type-starts-with .form-check-input').attr('id', 'inclusion_urls_apply_match_type_starts_with_' + counter + '_item_' + urlCounter).attr('name', 'searchable_url_setting[inclusion_urls][' + counter + '][filters][' + urlCounter + '][apply_match_type]');
                tpl.find('.apply-match-type-starts-with .form-check-label').attr('for', 'inclusion_urls_apply_match_type_starts_with_' + counter + '_item_' + urlCounter);
                tpl.find('.apply-match-type-exact-match .form-check-input').attr('id', 'inclusion_urls_apply_match_type_exact_match_' + counter + '_item_' + urlCounter).attr('name', 'searchable_url_setting[inclusion_urls][' + counter + '][filters][' + urlCounter + '][apply_match_type]');
                tpl.find('.apply-match-type-exact-match .form-check-label').attr('for', 'inclusion_urls_apply_match_type_exact_match_' + counter + '_item_' + urlCounter);
                tpl.find('.form-url').attr('name', 'searchable_url_setting[inclusion_urls][' + counter + '][filters][' + urlCounter + '][url]');

                parent.find('.url-options-group').append(tpl.html());
            })
            .on('click', '.inclusion-urls-holder .remove-link', function () {
                const elUrlOptionsGroup = $(this).closest('.url-options-group');

                if (elUrlOptionsGroup.find('.url-options-holder').length <= 1) {
                    return;
                }

                $(this).closest('.url-options-holder').remove();
            })
            .on('click', '.inclusion-urls-holder .remove-row', function () {
                $(this).closest('.form-group').remove();
            })

            .on('click', '.inclusion-pdfs-holder .add-row', function () {
                let parent = $(this).closest('.inclusion-pdfs-holder'),
                    tpl = $('<div/>').html($('#inclusion_pdf_tpl').html()),
                    counter = parseInt($('.inclusion-pdfs-holder .form-group:last-child').data('counter') || 0) + 1;

                tpl.find('.form-group').attr('data-counter', counter).data('counter', counter);
                tpl.find('.form-select').attr('id', 'inclusion_pdfs_' + counter + '_question_id').attr('name', 'searchable_url_setting[inclusion_pdfs][' + counter + '][question_id]');
                tpl.find('.form-pdf').attr('name', 'searchable_url_setting[inclusion_pdfs][' + counter + '][file]').attr('id', 'inclusion_pdfs_' + counter);
                tpl.find('.pdf-file-button').attr('for', 'inclusion_pdfs_' + counter);

                parent.find('.inclusion-pdfs-form').append(tpl.html());
                initSearchableSelect($('.inclusion-pdfs-holder .form-group:last-child .searchable-select'));
            })
            .on('click', '.inclusion-pdfs-holder .remove-row', function () {
                $(this).closest('.form-group').remove();
            })
            .on('click', '.calendar-inclusion-urls-holder .add-row', function () {
                let parent = $(this).closest('.calendar-inclusion-urls-holder'),
                    tpl = $('<div/>').html($('#calendar_inclusion_url_tpl').html()),
                    counter = parseInt(parent.find('.form-group:last-child').data('counter') || 0) + 1,
                    parentCounter = parseInt($(this).closest('.subdomain-style-setting-item').data('counter') || 0),
                    parentFieldName = parent.data('parent-field-name');

                const parentFieldNameWithIndex = parentFieldName === 'subsite_styling' ? parentFieldName + '[' + parentCounter + ']' : parentFieldName;

                tpl.find('.form-group').attr('data-counter', counter).data('counter', counter);
                tpl.find('.question-type-field').attr('name', parentFieldNameWithIndex + '[calendar_inclusion_urls][' + counter + '][type]');
                tpl.find('.form-select').attr('id', parentFieldName + '_' + parentCounter + '_' + '_calendar_inclusion_urls_' + counter + '_bot_item_id').attr('name', parentFieldNameWithIndex + '[calendar_inclusion_urls][' + counter + '][question_id]');
                tpl.find('.form-url').attr('name', parentFieldNameWithIndex + '[calendar_inclusion_urls][' + counter + '][urls][0]');


                parent.find('.calendar-inclusion-urls-form').append(tpl.html());
                initSearchableSelect(parent.find('.form-group:last-child .searchable-select'));
            })
            .on('click', '.calendar-inclusion-urls-holder .add-link', function () {
                let parent = $(this).closest('.url-options-wrapper'),
                    parentCalendarInclusionHolder = parent.closest('.calendar-inclusion-urls-holder'),
                    tpl = $('<div/>').html($('#calendar_inclusion_url_tpl .url-options-group').html()),
                    counter = parseInt(parent.closest('.form-group').data('counter') || 0),
                    urlCounter = parseInt(parent.find('.url-options-group .url-options-holder:last-child').data('counter') || 0) + 1,
                    parentCounter = parseInt($(this).closest('.subdomain-style-setting-item').data('counter') || 0),
                    parentFieldName = parentCalendarInclusionHolder.data('parent-field-name');

                const parentFieldNameWithIndex = parentFieldName === 'subsite_styling' ? parentFieldName + '[' + parentCounter + ']' : parentFieldName;

                tpl.find('.url-options-holder').attr('data-counter', urlCounter).data('counter', urlCounter);
                tpl.find('.form-url').attr('name', parentFieldNameWithIndex + '[calendar_inclusion_urls][' + counter + '][urls][' + urlCounter + ']');

                parent.find('.url-options-group').append(tpl.html());
            })
            .on('click', '.calendar-inclusion-urls-holder .remove-row', function () {
                $(this).closest('.form-group').remove();
            })
            .on('click', '.calendar-inclusion-urls-holder .remove-link', function () {
                const elUrlOptionsGroup = $(this).closest('.url-options-group');

                if (elUrlOptionsGroup.find('.url-options-holder').length <= 1) {
                    return;
                }

                $(this).closest('.url-options-holder').remove();
            });
    }

    function onSubmitOtherSetting ( e ) {
        e.preventDefault();

        $('#root_urls_wrapper .root-urls-item').each(function ( index ) {
            const fieldName = 'other_setting[crawl_root_urls][' + index + ']';
            $(this).find('.crawl-input-id').attr('name', fieldName + '[id]');
            $(this).find('.crawl-input-url').attr('name', fieldName + '[url]');
        });

        $('#scrape_urls_wrapper .root-urls-item').each(function ( index ) {
            const fieldName = 'other_setting[scrape_urls][' + index + ']';
            $(this).find('.scrape-input-id').attr('name', fieldName + '[id]');
            $(this).find('.scrape-input-url').attr('name', fieldName + '[url]');
            $(this).find('.scrape-input-interval').attr('name', fieldName + '[scrape_interval]');
        });

        $(this)[0].submit();
    }

    function onClickedRecrawl(e) {
        let message = $(this).data('message');
        let route = $(this).data('url');
        let targetModel = $(this).data('bs-target');

        $(targetModel).find('form').attr('action', route);
        $(targetModel).find('.header-sub-text').html(message);
    }

    function errorMessageElement(message) {
        return `<div class="invalid-feedback d-block" role="alert">
                <strong>${message}</strong>
            </div>`;
    }

    function scrollToElement($element) {
        window.scrollTo({
            top: $element.offset().top - 100,
            behavior: 'auto'
        });
    }

    function validateSearchableUrlFormInclusions(elInclusionHolder) {
        // clean up previous validation messages
        elInclusionHolder.find('.invalid-feedback').remove();

        elInclusionHolder.find('.searchable-select-group > .form-group').each(function () {
            const elFormGroup = $(this);
            const elSelect = elFormGroup.find('.form-select');
            const elUrls = elFormGroup.find('.url-options-holder .form-url');
            const elPdf = elFormGroup.find('.pdf-options-wrapper .form-pdf');
            let hasSelectedBotItem = !isEmpty(elSelect.val());
            let hasUrls = false;
            let hasPdf = false;

            elUrls.each(function () {
                const elUrl = $(this);
                if (elUrl.val()) {
                    hasUrls = true;
                }
            });

           if (elPdf.length) {
               hasPdf = !isEmpty(elFormGroup.find('.pdf-id').val()) || !isEmpty(elPdf.val());
           }

            // For URL inclusions
            if (elUrls.length && (hasUrls !== hasSelectedBotItem)) {
                if (!hasUrls) {
                    elFormGroup.find('.url-options-group .url-field-holder:first').append(errorMessageElement('Please provide at least one URL'));
                }
                if (!hasSelectedBotItem) {
                    elFormGroup.find('.question-field').append(errorMessageElement('Please select a bot item'));
                }
            }

            // For PDF inclusions
            if (elPdf.length && (hasPdf !== hasSelectedBotItem)) {
                if (!hasPdf) {
                    elFormGroup.find('.pdf-options-wrapper .pdf-display').html(errorMessageElement('Please provide a PDF file'));
                }
                if (!hasSelectedBotItem) {
                    elFormGroup.find('.question-field').append(errorMessageElement('Please select a bot item'));
                }
            }
        });
    }

    function initSearchableUrlFormValidation() {
        const elSearchableUrlForm = $('#searchable_url_form');
        const elCalendarInclusionHolder = $('.calendar-inclusion-urls-holder');
        const elUrlInclusion = $('.inclusion-urls-holder');
        const elPdfInclusion = $('.inclusion-pdfs-holder');

        elSearchableUrlForm.on('submit', function(e) {
            e.preventDefault();

            validateSearchableUrlFormInclusions(elCalendarInclusionHolder);
            validateSearchableUrlFormInclusions(elUrlInclusion);
            validateSearchableUrlFormInclusions(elPdfInclusion);
            const elFirstInvalidFeedback = $('.calendar-inclusion-urls-holder, .inclusion-urls-holder, .inclusion-pdfs-holder').find('.invalid-feedback:first');
            if (elFirstInvalidFeedback[0]) {
                scrollToElement(elFirstInvalidFeedback);
                return false;
            }

            elSearchableUrlForm[0].submit()
        });
    }

    return {
        init: function () {
            initImageInputs();
            initColorPickers();
            initWysiwyg();
            updateChatBotPreviewStyling();
            initSearchableSelectAjax();
            initSearchableSelect();
            initSearchableSelect($('.calendar-inclusion-urls-holder .searchable-select'));
            initMultiSelect();

            setupImageUploadField();
            setupColorPicker();
            setupSubdomainStyleFieldAttributes();

            $('.preview-holder').addClass('active');

            $('#new_user_prompt_enable').on('change', function () {
                $('.toggle_field_prompt').toggleClass('d-none', !$(this).is(':checked'));
            });

            $('body')
                .on('change', '#icon_size,[name="display_chatbot_name"]', updateChatBotPreviewStyling)
                .on('input', '[type="range"]', function () {
                    $(this).closest('.range-field-holder').find('.range-field-value').text($(this).val());
                })
                .on('change', '[name="configurable_response_link_type"]', function () {
                    let elTextbox = $('#configurable_textbox');
                    if ($(this).val() === 'custom') {
                        elTextbox.removeClass('d-none');
                        return;
                    }
                    elTextbox.find('[name="configurable_response_link_custom_text"]').val('');
                    elTextbox.addClass('d-none');
                })
                .on('change', '[name="configurable_loading_indicator_type"]', function () {
                    let elTextbox = $('#configurable_loading_indicator_textbox');
                    if ($(this).val() === 'text') {
                        elTextbox.removeClass('d-none');
                        return;
                    }
                    elTextbox.find('[name="configurable_loading_indicator_text"]').val('');
                    elTextbox.addClass('d-none');
                })
                .on('change', '#window_radius', updateWindowRadius)
                .on('change', '[name="response_style"]', updateResponseStyle)
                .on('change', '[name="response_style_icon"]', updateChatBotPreviewStyling)
                .on('change', '#chatbot_name', updateChatBotPreviewStyling)
                .on('change', '.form-pdf', updateChatPdfFile)
                .on('change', '#fallback_pdf_file_field', updateFallbackPdfFile)
                .on('change', '.indexing-mode-field', function () {
                    $('#crawl_urls_wrapper').toggleClass('d-none', $(this).val() !== INDEX_MODE_CRAWL)
                })
                .on('change', '#document_limit_type', function (  ) {
                    $('label[for="document_limit_value"]').text($(this).val() === 'page' ? 'Document Page Limit' : 'Document Token Limit');
                })
                .on('click', '#fallback_pdf_file_holder .pdf-file-remove', removeFallbackPdfFile)
                .on('submit', '#subdomain_style_form', onSubdomainStyleFormSubmit)
                .on('submit', '#other_setting_form', onSubmitOtherSetting)
                .on('click', '.crawl-action-button', onClickedRecrawl);

            $('.lead-generation-recipients-holder').on('click', '.add-link', function () {
                let parent = $(this).closest('.lead-generation-recipients-holder'),
                    tpl = $('#lead_generation_tpl').html();

                parent.find('.lead-generation-recipients-form').append(tpl);
            }).on('click', '.remove-link', function () {
                $(this).closest('.form-group').remove();
            });

            $('.root-urls-holder').on('click', '.add-link', function () {
                let parent = $(this).closest('.root-urls-holder'),
                    tpl = $($(this).data('target')).html();

                parent.find('.root-urls-form').append(tpl);
            }).on('click', '.remove-link', function () {
                $(this).closest('.form-group').remove();
            });

            $('#subsite_field_holder')
                .on('change', '[name="other_setting[subsite_detection_mode_type]"]', function () {
                    const parent = $(this).closest('.subsite-detection-mode-wrapper');
                    const isCustomList = $(this).val() === 'custom-list';
                    parent.find('.subsite-detection-mode-content').toggleClass('d-none', !isCustomList);
                })
                .on('click', '.add-link', function () {
                    let parent = $(this).closest('.subsite-detection-mode-wrapper'),
                        tpl = $('#subsite_field_url_tpl').html();

                    parent.find('.subsite-detection-mode-form').append(tpl);
                })
                .on('click', '.remove-link', function () {
                    $(this).closest('.form-group').remove();
                });

            $('.subdomain-style-setting-wrapper').on('click', '.add-subdomain-style', onClickedAddSubdomainRow).on('click', '.remove-subdomain-style', function () {
                $(this).closest('.subdomain-style-setting-item').remove();
            });

            setupSearchableUrlsSetting();

            initSearchableUrlFormValidation();
        }
    };

})();

// Provide the route name
App.registerRoute('organizations.bots.setting', App.BotSetting.init);
App.registerRoute('bots.setting', App.BotSetting.init);

export default App.BotSetting;
